import {EmbedCodeExtractor} from "./types"

/**
 * Both Riddle embed generations — the older plain-`<iframe>` style and the current
 * `riddle2-wrapper`/`embedV2.js` style — carry a `data-rid-id="<id>"` attribute on their
 * outermost element, so a single pattern covers either shape. The surrounding-attribute
 * quantifiers are bounded (`{0,300}`, well past anything a real Riddle embed needs) rather
 * than open-ended `[^>]*`/`.*`: an unbounded version of this pattern is what caused a
 * regex-DoS in PR review (AWS Security Agent) — ~1.5s for a 50KB non-matching input,
 * since it was retried at every `<` and each retry cost scaled with the remaining input.
 * Bounding every quantifier caps the cost of each retry to a small constant instead, so
 * total cost stays linear in input length regardless of shape (proven below in tests).
 */
const RIDDLE_EMBED_PATTERN = /<[a-zA-Z][a-zA-Z0-9-]{0,20}\b[^<>]{0,300}\bdata-rid-id="([a-zA-Z0-9]{1,64})"[^<>]{0,300}>/i

/**
 * Converts a pasted Riddle embed code to the canonical `https://www.riddle.com/view/<id>`
 * URL, so it resolves via the Riddle provider identically to a pasted link instead of
 * CustomEmbedCode's verbatim passthrough (add-riddle-webembed-provider).
 */
export const riddlePreProcessor: EmbedCodeExtractor = (input: string) => {
  const match = RIDDLE_EMBED_PATTERN.exec(input)
  return match != null ? `https://www.riddle.com/view/${match[1]}` : null
}
